const URL_PATTERN = /https?:\/\/[^\s，。！？、；;）)\]】}>]+/giu;

export function parseSharedText(rawValue) {
  const raw = String(rawValue || "").trim();
  const matchedUrl = raw.match(URL_PATTERN)?.[0] || bareUrl(raw);
  if (!matchedUrl) {
    return { title: normalizeText(raw), sourceUrl: null, sourceTitle: null, sourceDomain: null };
  }

  const sourceUrl = normalizeSourceUrl(matchedUrl);
  const sourceDomain = domainFor(sourceUrl);
  const textBeforeUrl = normalizeText(raw.slice(0, Math.max(0, raw.indexOf(matchedUrl))));
  const textWithoutUrls = normalizeText(raw.replace(URL_PATTERN, " "));
  const title = platformTitle(sourceDomain, textBeforeUrl, textWithoutUrls) || titleFromUrl(sourceUrl);

  return { title, sourceUrl, sourceTitle: title, sourceDomain };
}

function platformTitle(domain, before, withoutUrls) {
  if (isDomain(domain, ["xhslink.cn", "xiaohongshu.com"])) return xiaohongshuTitle(before || withoutUrls);
  if (isDomain(domain, ["douyin.com", "v.douyin.com"])) return douyinTitle(before || withoutUrls);
  if (isDomain(domain, ["b23.tv", "bilibili.com"])) return bilibiliTitle(withoutUrls);
  return genericTitle(before || withoutUrls);
}

function xiaohongshuTitle(value) {
  return cleanTitle(value
    .replace(/^小红书\s*[:：]\s*/u, "")
    .replace(/\s*小伙伴复制一下[\s\S]*$/u, "")
    .replace(/\s*打开[【\[]?小红书[】\]]?[\s\S]*$/u, ""));
}

function douyinTitle(value) {
  return cleanTitle(value
    .replace(/^抖音\s*[:：]\s*/u, "")
    .replace(/^\d+(?:\.\d+)?\s*/u, "")
    .replace(/^复制打开抖音[，,]?\s*看看\s*/u, "")
    .replace(/^【[^】]*?(?:的作品)?】\s*/u, "")
    .split(/\s*#\s*/u)[0]
    .replace(/\s*(?:\.\.\.|…+)\s*$/u, ""));
}

function bilibiliTitle(value) {
  const bracketed = value.match(/【([^】]+)】/u)?.[1];
  return cleanTitle((bracketed || value)
    .replace(/[-—–_\s]*哔哩哔哩\s*$/u, "")
    .replace(/^哔哩哔哩\s*[:：]\s*/u, ""));
}

function genericTitle(value) {
  return cleanTitle(value
    .replace(/\s*(?:复制|点击)(?:链接|一下)?[\s\S]*$/u, "")
    .replace(/\s*打开[【\[]?[^】\]]+[】\]]?就能看到[\s\S]*$/u, ""));
}

function cleanTitle(value) {
  return normalizeText(value)
    .replace(/^[\s:：|｜,，;；-]+/u, "")
    .replace(/[\s|｜;；-]+$/u, "")
    .trim();
}

function normalizeText(value) {
  return String(value || "").replace(/\s+/gu, " ").trim();
}

function normalizeSourceUrl(value) {
  return String(value || "")
    .replace(/[)\]】}>，。！？、；;]+$/gu, "")
    .replace(/:+$/gu, "");
}

function bareUrl(raw) {
  return /^(?:www\.)?[^\s.]+(?:\.[^\s./]+)+(?:\/\S*)?$/iu.test(raw) ? `https://${raw}` : null;
}

function domainFor(value) {
  try {
    return new URL(value).hostname.replace(/^www\./u, "").toLowerCase();
  } catch {
    return null;
  }
}

function titleFromUrl(value) {
  try {
    const url = new URL(value);
    const domain = url.hostname.replace(/^www\./u, "");
    return domain + (url.pathname !== "/" ? decodeURIComponent(url.pathname).replace(/\/$/u, "") : "");
  } catch {
    return value;
  }
}

function isDomain(domain, candidates) {
  return Boolean(domain && candidates.some((candidate) => domain === candidate || domain.endsWith(`.${candidate}`)));
}
